export default "__VITE_ASSET__CB41c9kZ__"